export default __webpack_public_path__ + "static/seokjun.jin-435ecc991be0c31d01ab65951e5d1f21.png";